module.exports = "<h1>\n  not-found works!\n</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = ./src/app/not-found/not-found.component.html
// module chunks = main